import { Typography } from "@mui/material";
import { getFilterDateValueKeys } from "utils/date-filter.util";
import { resolveDatabaseTimeframe } from "utils/database-timeframe.util";

export default function DatabaseTimeframeNote({ database, timeframe, startDate, endDate }) {
  const { note } = resolveDatabaseTimeframe(
    database, getFilterDateValueKeys(timeframe, startDate, endDate)
  );
  return note ? (
    <Typography component="p" variant="caption" color="text.secondary" role="note" sx={{ mt: 1, mb: 0 }}>
      {note}
    </Typography>
  ) : null;
}
